import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {
  getNotificationCount,
  getNotifications,
  postNotificationCount,
} from '../../api/endpoints/projectApi';
import {NotificationResponse} from '../../api/types/notifications.type';

export const useGetNotifications = (
  onSuccess?: (data: NotificationResponse[]) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<NotificationResponse[], Error>({
    mutationFn: getNotifications,
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetNotificationsCount = () => {
  return useQuery<number, Error>({
    queryKey: ['notificationsCount'],
    queryFn: () => getNotificationCount(),
    retry: 2,
    staleTime: 1000 * 60 * 10,
  });
};

export const usePostNotificationCount = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  const queryClient = useQueryClient();
  return useMutation<any, Error, any>({
    mutationFn: postNotificationCount,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['notificationsCount']});
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
